import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import EditLayoutModal from "../editLayoutModal/EditLayoutModal";

export const EditLayoutButton = ({
  layoutConfigKey,
  layoutDisplayName,
  fields,
  fieldRenderer,
  onSuccess = () => {},
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        Edit Layout
      </Button>
      {open && (
        <EditLayoutModal
          visible={open}
          onCancel={() => setOpen(false)}
          layoutConfigKey={layoutConfigKey}
          layoutDisplayName={layoutDisplayName}
          defaultFields={fields}
          fieldRenderer={fieldRenderer}
          onSave={onSuccess}
        />
      )}
    </>
  );
};
